import React from 'react'

export default function Loader() {
    return (
        <>
        <center>
            <div class="loading"></div>
        </center>
            
        </>
    )
}
